export default __webpack_public_path__ + "static/media/Chainlink.95418b03.gif";